export const CUSTOMER_STAMP = "WHAT YOUR CUSTOMER EXPERIENCES";

export const CUSTOMER_HEADLINE = {
  lead: "Your Customers Feel Like",
  accent: "You're Always on the Line",
};

export const CUSTOMER_SCAN_TAG = "Sunday · 10 PM · Office closed";

export const CUSTOMER_SUBHEAD =
  "They message when you're on a job or asleep. Your digital employee replies in seconds, asks the right questions, and books the inspection — before your competitor's voicemail picks up.";

export const CUSTOMER_CHAT = {
  statusTime: "10:14 PM",
  statusDay: "Sunday",
  messages: [
    {
      id: "customer-1",
      role: "customer",
      text: "Roof leaking badly — can someone come out tonight?",
    },
    {
      id: "ai-1",
      role: "ai",
      text: "Hi — I'm here. What's your address? Tile or metal roof?",
    },
    {
      id: "customer-2",
      role: "customer",
      text: "42 George St — tile, leak near the chimney",
    },
    {
      id: "ai-2",
      role: "ai",
      text: "Got it. Inspection booked Thu 9:00 AM ✓",
      highlight: true,
    },
  ],
};

export const CUSTOMER_BEATS = [
  {
    id: "when",
    marker: "01",
    value: "10 PM",
    label: "They text when you're closed",
    detail: "Sunday night — your crew is offline",
  },
  {
    id: "speed",
    marker: "02",
    value: "9 sec",
    label: "Answered before voicemail",
    detail: "Feels like your best office manager — not a bot",
    highlight: true,
  },
  {
    id: "outcome",
    marker: "03",
    value: "BOOKED",
    label: "Walks away with an appointment",
    detail: 'Not a "we\'ll call you back"',
  },
];

export const CUSTOMER_PAYOFF = {
  prefix: "Lead to booked inspection in under",
  highlight: "9 seconds",
  suffix: "— while you sleep.",
};
